import BakedTableSurface from 'components/table/BakedTableSurface';
import TeenPattiTableTopDown from 'components/table/TeenPattiTableTopDown';
import type { SeatLayoutProfile } from 'constants/seatLayout';

interface TableSurfaceProps {
  showSeatGuides?: boolean;
  previewMode?: boolean;
  liveMode?: boolean;
  layoutProfile?: SeatLayoutProfile;
  /** Use photoreal baked texture (default). Set false for SVG fallback. */
  useBakedTexture?: boolean;
}

export default function TableSurface({
  showSeatGuides = false,
  previewMode = false,
  liveMode = true,
  layoutProfile = 'desktop',
  useBakedTexture = false,
}: TableSurfaceProps) {
  return (
    <div className="tp-table-asset-wrap relative h-full w-full">
      <div className="tp-table-floor-shadow absolute inset-x-[4%] -bottom-[6%] h-[14%] rounded-[50%] blur-xl" aria-hidden />
      {useBakedTexture ? (
        <BakedTableSurface showSeatGuides={showSeatGuides} previewMode={previewMode} />
      ) : (
        <TeenPattiTableTopDown
          showSeatGuides={showSeatGuides}
          previewMode={previewMode}
          liveMode={liveMode}
          layoutProfile={layoutProfile}
        />
      )}
    </div>
  );
}
